/* Load Components */
import { FormBox } from "../../../../../../../utils/forms/components/FormBoxes";

/* Load Constants */
import * as MEGAPOT_CONSTS from "./MegapotConfigurationSection.constants";
import buildFormGridFields from "../../../../../../../utils/forms/builders/build-form-grid-fields";
import buildSchemaCompliantDefinition from "../../../../../../../utils/forms/builders/build-schema-compliant-definition";

export const megapotConfigBox: (schema, megapotProviders,megapotServers, form_values) => FormBox[] = (schema, megapotProviders,megapotServers, form_values) => {
    const megapotFormDefinition =
        MEGAPOT_CONSTS.MEGAPOT_FORM_DEFINITION(megapotProviders,megapotServers, form_values);

    let schemaDefinitions = { ...schema };


    const formDefinition = buildSchemaCompliantDefinition(
        schemaDefinitions,
        megapotFormDefinition
    );

    return [
        {
            fields: buildFormGridFields(schemaDefinitions, formDefinition),
            columnClass: "col-12"
        }
    ];
};
